module.exports = __webpack_public_path__ + "static/media/subaru-forester-1.0107b994.jpg";